import * as React from 'react';
import Box from '@mui/material/Box';
import { Grid, Button } from '@mui/material';
import styles from './logicalChooser.module.scss'
import resetIcon from '../../assets/resetIcon.svg'
import { v4 as uuid } from 'uuid';
import Options from './Options';

const LogicalChooser = ({ data, parentState, updateParentState, optionHeader }) => {
    const [state, setState] = React.useState(parentState)
    const [ isDisabled, setIsDisabled ] = React.useState(false)
    let defaultAttributes = []
    if (state.attributes && state.attributes.length > 1) {
        let remainingAttributes = []
        const selectedAttributeSet = new Set()
        const selectedAttributes = []
        state.attributes.forEach(item => {
            selectedAttributeSet.add(item.attribute)
            if(item.attribute){
                selectedAttributes.push([item.attribute])
            }
        })
        
        data.forEach(item => {
            if(!selectedAttributeSet.has(item.displayName)){
                remainingAttributes.push(item.displayName)
            }
        })

        selectedAttributes[selectedAttributes.length - 1] = selectedAttributes[selectedAttributes.length - 1].concat(...remainingAttributes)
        defaultAttributes = selectedAttributes
        
    } else {
        defaultAttributes = [data.map(item => item.displayName)]
    }
    const [attributes, setAttributes] = React.useState(defaultAttributes)
    const [uuids, setUuids] = React.useState([])
    if (uuids?.length !== state?.attributes?.length && state?.attributes?.length > 0) {
        let newUuids = [...uuids]
        state.attributes.forEach((item, index) => {
            newUuids[index] = uuid()
        })
        setUuids([...newUuids])
    }
    const handleAddAttribute = () => {
        uuids.push(uuid())
        const newAttributes = [...attributes]
        const newStateAttributes = [...state.attributes]
        if (newStateAttributes.length === 0) {
            newStateAttributes.push({})
            setState(prevState => ({ ...prevState, attributes: newStateAttributes }))
            return;
        }
        const lastAttributeArray = newAttributes[newAttributes.length - 1]
        const selectedAttritbute = newStateAttributes[newStateAttributes.length - 1]?.attribute
        let firstValueArray, remainingArray;
        if (selectedAttritbute) {
            const selectedAttributeIndex = lastAttributeArray.findIndex(item => selectedAttritbute === item)
            remainingArray = [...lastAttributeArray]
            firstValueArray = remainingArray.splice(selectedAttributeIndex, 1)
        } else {
            firstValueArray = lastAttributeArray.slice(0, 1)
            remainingArray = lastAttributeArray.slice(1, lastAttributeArray.length)
            newStateAttributes[newStateAttributes.length - 1].attribute = firstValueArray[0]
        }

        newAttributes[newAttributes.length - 1] = firstValueArray
        newAttributes[newAttributes.length] = remainingArray
        if (remainingArray.length === 1) {
            newStateAttributes[newStateAttributes.length] = {
                attribute: remainingArray[0],
                operator:"",
                value: ""
            }
        }else{
            newStateAttributes[newStateAttributes.length] = {
                attribute:"",
                operator:"",
                value: ""
            }
        }
        setAttributes(newAttributes)
        setState(prevState => ({ ...prevState, attributes: newStateAttributes }))
        setUuids([...uuids])
    }
    const handleRemoveAttribute = (index) => {
        uuids.splice(index, 1)
        let newAttributes = [...attributes]
        const deletedAttribute = newAttributes.splice(index, 1)
        newAttributes[newAttributes.length - 1] = newAttributes[newAttributes.length - 1].concat(...deletedAttribute)
        setAttributes(newAttributes)
        const newStateAttributes = [...state.attributes]
        newStateAttributes.splice(index, 1)
        setState(prevState => ({ ...prevState, attributes: newStateAttributes }))
        setUuids([...uuids])
    }
    const updateAttribute = (index, attribute) => {
        const newStateAttributes = [...state.attributes]
        newStateAttributes[index] = attribute
        setState(prevState => ({ ...prevState, attributes: newStateAttributes }))
    }
    const handleResetFilters = () => {
        setAttributes([data.map(item => item.displayName)])
        setState(prevState => ({ ...prevState, attributes: [{
                attribute: "",
                operator:"",
                value: ""
            }]}))
        setUuids([])
    }

    React.useEffect(() => {
        updateParentState.attributes([...state.attributes])
        if (state.attributes.length === 0) {
            handleAddAttribute()
        }
        const lastAttribute = state.attributes[state.attributes.length - 1]
        if(lastAttribute.attribute && lastAttribute.operator && lastAttribute.value) {
            setIsDisabled(false)
        }else {
            setIsDisabled(true)
        }
    }, [state.attributes])
    
    return (
        <Box className={styles.logicalChooserContainer}>
            {state.attributes.map((item, index) => <Options key={uuids[index]}
                data={data}
                attributes={attributes[index]}
                optionHeader={optionHeader}
                parentState={item}
                index={index}
                total={state.attributes.length}
                remove={handleRemoveAttribute}
                updateParentState={updateAttribute}
                operator={'AND'} />)}
            <Grid container className={styles.buttonContainer}>
                {state.attributes.length < Object.keys(data).length && <Grid item xs={12}>
                    <Button className={`${styles.button} ${isDisabled ? styles.btnGray : "" }`} variant='outlined' onClick={handleAddAttribute} disabled={isDisabled}>
                        + Add another attribute</Button>
                </Grid>}
                <Grid container item xs={12} justifyContent="space-between" sx={{ marginTop: "92px" }}>
                    <Grid item xs={3}>
                        <Button className={`${styles.btn} ${styles.resetBtn}`} startIcon={<img src={resetIcon} />} onClick={handleResetFilters}>Reset All Filters</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

export default LogicalChooser
